uniform vec2 uResolution;
uniform float uSize;
uniform float uProgress;
uniform vec3 uColorA;
uniform vec3 uColorB;
uniform float uTime;

attribute vec3 aPositionTarget;
attribute float aSize;

varying vec3 vColor;

#include ../includes/simplexNoise3d.glsl

void main()
{
    float noiseOrigin = simplexNoise3d(position* 0.2);
    float noiseTarget = simplexNoise3d(aPositionTarget*0.2);
    float noise = mix(noiseOrigin,noiseTarget,uProgress);
    noise = smoothstep(-1.0,1.0,noise);

    float duration = 0.4;
    float delay = (1.0 - duration) * noise;
    float end = delay+duration;


    vec3 randomnPosition = position;
    float randomNoise = simplexNoise3d(vec3(position * 1.0 + uTime * 0.2)); // snoise, simplex noise

    randomnPosition += normalize(position) * randomNoise * 0.1; 

    float progress = smoothstep(delay,end,uProgress);
    // vec3 mixedPosition = mix(randomnPosition,aPositionTarget,progress);
    vec3 morphedPosition = mix(randomnPosition, aPositionTarget, progress);

    // Wiggling after morph
    float afterMorphNoise = simplexNoise3d(vec3(aPositionTarget * 1.0 + uTime * 0.2));
    vec3 afterMorphOffset = normalize(aPositionTarget) * afterMorphNoise * 0.1;

    // Final position with wiggle after morph
    vec3 finalPosition = morphedPosition + afterMorphOffset * ( progress);
    // Final position
    vec4 modelPosition = modelMatrix * vec4(finalPosition, 1.0);
    vec4 viewPosition = viewMatrix * modelPosition;
    vec4 projectedPosition = projectionMatrix * viewPosition;
    gl_Position = projectedPosition ;

    // Point size
    gl_PointSize = uSize * uResolution.y * aSize;
    gl_PointSize *= (1.0 / - viewPosition.z);

    vColor = mix(uColorA,uColorB,noise);
}